import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import picc1 from "../../assets/calendar/calendarnormal1.jpg";
import picc2 from "../../assets/calendar/calendarnormal2.jpg";
import picc3 from "../../assets/calendar/calendarnormal3.jpg";
import picc_nurse from "../../assets/calendar/calendarnormal_nurse.jpg";
import MetaTags from "react-meta-tags";

export default class Page1 extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร Calendar's Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="0" sm="0"></MDBCol>
                    <MDBCol lg="10" md="12" sm="12">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardTitle>
                                    ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคปกติ (จันทร์-ศุกร์)
                                </MDBCardTitle>
                                <MDBCardText>
                                    <img style={{ margin: "0px 0px 10px 0px " }} src={picc1} width="100%" />
                                    <img style={{ margin: "0px 0px 10px 0px " }} src={picc2} width="100%" />
                                    <img style={{ margin: "0px 0px 10px 0px " }} src={picc3} width="100%" />
                                    <img style={{ margin: "0px 0px 10px 0px " }} src={picc_nurse} width="100%" />
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="0" sm="0"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}